import {
  DROPDOWN_FILTER_COLLAPSABLE_TYPE,
  FILTER_COLLAPSABLE_SECTION_TYPE,
} from '../../../packages/ui/organisms/table/filter';

export const tableColumns = [
  { id: 'sessionDate', label: 'Session Date & Time', sortable: false },
  { id: 'provider', label: 'Provider', sortable: false },
  { id: 'member', label: 'Member', sortable: false },
  { id: 'sessionType', label: 'Service', sortable: false },
  { id: 'totalAmount', label: 'Amount', sortable: false },
  // TODO: will implement daysPastDue in another ticket
  // { id: 'daysPastDue', label: 'Days past due', sortable: false },
  { id: 'dueDate', label: 'Due Date & Time', sortable: false },
  { id: 'reason', label: 'Reason', sortable: false },
  { id: 'status', label: 'Status', sortable: false },
  { id: 'actions', label: '', sortable: false },
];

export const INVOICES_STATUSES = [
  { label: 'New', value: 'NEW' },
  { label: 'Paid', value: 'PAID' },
  { label: 'On Hold', value: 'ON_HOLD' },
  { label: 'Write off', value: 'WRITE_OFF' },
  { label: 'Payment Failed', value: 'PAYMENT_FAILED' },
];

export const INVOICE_FAST_FILTERS = {
  ALL: 'ALL',
  NEW: 'NEW',
  PAID: 'PAID',
  ON_HOLD: 'ON_HOLD',
  WRITE_OFF: 'WRITE_OFF',
  PAYMENT_FAILED: 'PAYMENT_FAILED',
  PATIENT_RESP: 'PATIENT_RESP',
  NO_SHOW: 'NO_SHOW',
  ELIGIBLE_INSURANCE: 'ELIGIBLE_INSURANCE',
  MEDICAID: 'MEDICAID',
  COMMERCIAL: 'COMMERCIAL',
  CASH_PAYMENT: 'CASH_PAYMENT',
  VERIFICATION_FAILED: 'VERIFICATION_FAILED',
};

const getProviderFilterOptions = providers => {
  return {
    sectionTitle: DROPDOWN_FILTER_COLLAPSABLE_TYPE.PROVIDERS,
    sectionType: FILTER_COLLAPSABLE_SECTION_TYPE.DROPDOWN,
    sectionOptions: providers.map(provider => {
      return {
        label: provider.fullName,
        value: {
          name: provider.fullName,
          id: provider.providerId,
          designation: provider.designation,
          image: provider.profile,
        },
      };
    }),
  };
};

export const multiSelectFilterOptionsMock = providers => {
  return [
    {
      sectionTitle: 'Status',
      sectionType: FILTER_COLLAPSABLE_SECTION_TYPE.DEFAULT,
      sectionOptions: [
        { label: 'New', value: 'New' },
        { label: 'Paid', value: 'Paid' },
        { label: 'On Hold', value: 'On Hold' },
        { label: 'Write Off', value: 'Write Off' },
        { label: 'Payment Failed', value: 'Payment Failed' },
      ],
    },
    {
      sectionTitle: 'State',
      sectionType: FILTER_COLLAPSABLE_SECTION_TYPE.DEFAULT,
      sectionOptions: [
        { label: 'Texas', value: 'Texas' },
        { label: 'Florida', value: 'Florida' },
        { label: 'Connecticut', value: 'Connecticut' },
        { label: 'Virginia', value: 'Virginia' },
        { label: 'New Hampshire', value: 'New Hampshire' },
      ],
    },
    {
      sectionTitle: 'Role',
      sectionType: FILTER_COLLAPSABLE_SECTION_TYPE.DEFAULT,
      sectionOptions: [
        { label: 'Nurse Practitioner', value: 'Nurse Practitioner' },
        { label: 'Therapist', value: 'Therapist' },
        { label: 'Counselor', value: 'Counselor' },
        { label: 'Coach', value: 'Coach' },
        { label: 'Care Manager', value: 'Care Manager' },
        { label: 'Physician', value: 'Physician' },
      ],
    },
    getProviderFilterOptions(providers),
    {
      sectionTitle: 'Invoice Type',
      sectionType: FILTER_COLLAPSABLE_SECTION_TYPE.RADIO,
      sectionOptions: [
        { label: 'Patient Responsibility', value: 'Patient Responsibility' },
        { label: 'VOB Failed', value: 'Insurance Verification Failed' },
        { label: 'No show', value: 'No show' },
        { label: 'Eligible', value: 'Eligible Insurance' },
        { label: 'Medicaid', value: 'Medicaid insurance' },
        { label: 'Commercial', value: 'Commercial Insurance' },
        { label: 'Cash', value: 'Cash Payment' },
      ],
    },
    {
      sectionTitle: 'Apply Dates Filter on',
      sectionType: FILTER_COLLAPSABLE_SECTION_TYPE.RADIO,
      sectionOptions: [
        { label: 'Session Date', value: 'Session Date' },
        { label: 'Due Date', value: 'Due Date' },
        { label: 'Invoice Creation Date', value: 'Invoice Creation Date' },
      ],
      default: 'Session Time',
      skipInTag: true,
      useWithDateFilter: true,
    },
  ];
};
export const DATE_FILTER_TYPES = {
  'Due Time': 'DUE_DATE',
  'Invoice Creation Date': 'INVOICE_DATE',
  'Session Date': 'SESSION_DATE',
  '': '',
};
export const INVOICE_TYPES = {
  'Patient Responsibility': 'PATIENT_RESP',
  'Insurance Verification Failed': 'VERIFICATION_FAILED',
  'No show': 'NO_SHOW',
  'Eligible Insurance': 'ELIGIBLE_INSURANCE',
  'Medicaid insurance': 'MEDICAID',
  'Commercial Insurance': 'COMMERCIAL',
  'Cash Payment': 'CASH_PAYMENT',
  '': '',
};

// Invoice type tabs (for filtering logic)
export const INVOICE_TYPE_TABS = [
  INVOICE_FAST_FILTERS.PATIENT_RESP,
  INVOICE_FAST_FILTERS.NO_SHOW,
  INVOICE_FAST_FILTERS.ELIGIBLE_INSURANCE,
  INVOICE_FAST_FILTERS.MEDICAID,
  INVOICE_FAST_FILTERS.COMMERCIAL,
  INVOICE_FAST_FILTERS.CASH_PAYMENT,
  INVOICE_FAST_FILTERS.VERIFICATION_FAILED,
];

// Status tabs (for filtering logic)
export const STATUS_TABS = [
  INVOICE_FAST_FILTERS.NEW,
  INVOICE_FAST_FILTERS.PAID,
  INVOICE_FAST_FILTERS.ON_HOLD,
  INVOICE_FAST_FILTERS.WRITE_OFF,
  INVOICE_FAST_FILTERS.PAYMENT_FAILED,
];
